import { Loop as LoopIcon } from "@material-ui/icons";
import React, { FC } from "react";
import styled from "styled-components/macro";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const SmallButton = styled(Button)`
  padding: 8px;
  min-width: 0;
  border-radius: 50%;
  background: #233145;
  svg {
    width: 0.9em;
    height: 0.9em;
  }
`;

type PropsType = {
  onClick: (e?: React.MouseEvent<HTMLElement>) => void
}

const ReloadButton: FC<PropsType> = ({onClick}) => {
  const {t} = useTranslation()
  return (
    <SmallButton size="small" title={t('statsPage_Reload')} onClick={(e) => onClick(e)}>
      <LoopIcon />
    </SmallButton>
  )
}

export default ReloadButton
